<template>
  <div class="row justify-content-center">
    <div class="col-lg-12 col-md-7">
      <div class="card bg-secondary shadow border-0">
        <div class="card-body px-lg-5 py-lg-5">
          <div class="col-lg-12">
              <div class="card-header bg-transparent">
                <div class="mx-3 my-2">
                    <h3>Completa el siguiente formulario para solicitar crédito en Canplast México</h3>
                    <small>Los campos que aparecen con un asterísco (*) son obligatorios.</small>
                </div>
              </div>
              <div class="card-body mx-3 my-2">
                <div v-show="!showForm">
                  <div class="form-group row">
                    <div class="col-lg-5">
                      <label class="form-control-label">RFC *</label>
                    </div>
                    <div class="col-lg-4"> 
                      <div class="form-group">
                        <input type="text" 
                              v-model="rfc"
                              placeholder="Escribe el RFC"
                              class="form-control"
                              min="1"
                              required>
                      </div>
                    </div>
                  </div>
                  <hr>
                  <div class="text-right">
                    <base-button @click="validateRFC" :disabled='loadingRFC'>Continuar</base-button>
                  </div>
                </div>
                <form v-show="showForm" @submit.prevent="sendRequest()">
                  <div class="form-group row items-center">
                    <div class="col-lg-5">
                      <label class="form-control-label">Cliente *</label>
                    </div>
                    <div class="col-lg-7"> 
                      <div v-if="razonSocial && cardCode">
                        <span>{{razonSocial}}</span>
                        <p>{{cardCode}}</p>                    
                      </div>
                      <span v-else>Cargando...</span>
                    </div>
                  </div>
                  <hr>
                  <div class="form-group row">
                    <div class="col-lg-5">
                      <label class="form-control-label">Agente de ventas *</label>
                    </div>
                    <div class="col-lg-7"> 
                      <p v-if="agenteVentas">{{agenteVentas.SalesEmployeeName}}</p>
                      <span v-else>Cargando...</span>
                    </div>
                  </div>
                  <hr>
                  <div class="form-group row">
                    <div class="col-lg-5">
                      <label class="form-control-label">Régimen Fiscal *</label>
                    </div>
                    <div class="col-lg-7">
                      <p v-if="regimen">{{regimen.Name}}</p>
                      <span v-else>Cargando...</span>
                    </div>
                  </div>
                  <hr>
                  <div class="form-group row">
                    <div class="col-lg-5">
                      <label class="form-control-label">CFDI 4.0 *</label>
                    </div>
                    <div class="col-lg-7"> 
                      <p v-if="cfdi">{{cfdi.name}}</p>
                      <span v-else>Cargando...</span>
                    </div>
                  </div>
                  <hr>
                  <div class="form-group row">
                    <div class="col-lg-5">
                      <label class="form-control-label">Monto solicitado *</label>
                      <p>Monto de crédito solicitado</p>
                    </div>
                    <div class="col-lg-4"> 
                      <div class="form-group">
                        <input type="Number" 
                              v-model="monto"
                              placeholder="Ingresa el monto"
                              class="form-control"
                              min="1"
                              required>
                      </div>
                    </div>
                  </div>
                  <hr>
                  <div class="form-group row">
                    <div class="col-lg-5">
                      <label class="form-control-label">Plazo *</label>
                    </div>
                    <div class="col-lg-4"> 
                      <multiselect
                        v-model="plazo"
                        :options="plazoOptions"
                        placeholder="Selecciona el Plazo"
                        style="z-index: 999;"
                        >
                        </multiselect>
                    </div>
                  </div>
                  <hr>
                  <div class="form-group row">
                    <div class="col-lg-5">
                      <label class="form-control-label">Constancia Fiscal *</label>
                      <p>Anexa la cédula de identificación fiscal de la empresa.</p>
                    </div>
                    <div class="col-lg-6">
                      <vue2-dropzone ref="dzConstFiscal"
                                    id="dzConstFiscal"
                                    @vdropzone-success="dzSuccess"
                                    @vdropzone-max-files-exceeded="dzMaxFiles(files[0].dzId, $event)"
                                    :options="files[0].dzOpt"
                                    :useCustomSlot="true"
                                    class="border rounded">
                        <div class="dropzone-custom-content">
                          <h4 class="dropzone-custom-title">
                            Arrastra y suelta el archivo aquí
                          </h4>
                          <small class="text-muted">
                            ...o haz click para seleccionar el archivo desde tu computadora.
                          </small>
                        </div>
                      </vue2-dropzone>
                    </div>
                  </div>
                  <hr>
                  <div class="form-group row">
                    <div class="col-lg-5">
                      <label class="form-control-label">Comprobante de domicilio *</label>
                      <p>Anexa un comprobante de domicilio de la razón social qué sea igual a la de tu cédula fiscal. </p>
                    </div>
                    <div class="col-lg-6">
                      <vue2-dropzone ref="dzCompDomicilio" 
                                    id="dzCompDomicilio"
                                    @vdropzone-success="dzSuccess"
                                    @vdropzone-max-files-exceeded="dzMaxFiles(files[1].dzId, $event)"
                                    :options="files[1].dzOpt"
                                    :useCustomSlot="true"
                                    class="border rounded">
                        <div class="dropzone-custom-content">
                          <h4 class="dropzone-custom-title">
                            Arrastra y suelta el archivo aquí
                          </h4>
                          <small class="text-muted">
                            ...o haz click para seleccionar el archivo desde tu computadora.
                          </small>
                        </div>
                      </vue2-dropzone>
                    </div>
                  </div>
                  <hr>
                  <div class="form-group row">
                    <div class="col-lg-5">
                      <label class="form-control-label">Solicitud de Canplast *</label>
                      <p>Descarga y llena nuestra Solicitud de Crédito Canplast y anexa a continuación </p>
                      <a href="https://firebasestorage.googleapis.com/v0/b/canplast-mx.appspot.com/o/customers-web%2FSolicitudCredito.docx?alt=media&token=ab4d6699-b9dc-45f4-8070-5eaab8e7c20b" >
                        <base-button type="secondary" icon="fa fa-download">
                          Descargar Solicitud
                        </base-button> 
                      </a>    
                    </div>
                    <div class="col-lg-6">
                      <vue2-dropzone ref="dzSolicitudCP" 
                                    id="dzSolicitudCP"
                                    @vdropzone-success="dzSuccess"
                                    @vdropzone-max-files-exceeded="dzMaxFiles(files[2].dzId, $event)"
                                    :options="files[2].dzOpt"
                                    :useCustomSlot="true"
                                    class="border rounded">
                        <div class="dropzone-custom-content">
                          <h4 class="dropzone-custom-title">
                            Arrastra y suelta el archivo aquí
                          </h4>
                          <small class="text-muted">
                            ...o haz click para seleccionar el archivo desde tu computadora.
                          </small>
                        </div>
                      </vue2-dropzone>
                    </div>
                  </div>
                  <hr>
                  <div class="form-group row">
                    <div class="col-lg-5">
                      <label class="form-control-label">INE de Representante Legal *</label>
                      <p>Anexa INE de Representante Legal</p>
                    </div>
                    <div class="col-lg-6">
                      <vue2-dropzone ref="dzIneRep" 
                                    id="dzIneRep"
                                    @vdropzone-success="dzSuccess"
                                    @vdropzone-max-files-exceeded="dzMaxFiles(files[3].dzId, $event)"
                                    :options="files[3].dzOpt"
                                    :useCustomSlot="true"
                                    class="border rounded">
                        <div class="dropzone-custom-content">
                          <h4 class="dropzone-custom-title">
                            Arrastra y suelta el archivo aquí
                          </h4>
                          <small class="text-muted">
                            ...o haz click para seleccionar el archivo desde tu computadora.
                          </small>
                        </div>
                      </vue2-dropzone>
                    </div>
                  </div>
                  <hr>
                  <div class="form-group row">
                    <div class="col-lg-5">
                      <label class="form-control-label">Acta Constitutiva/Poder * (Persona Moral)</label>
                      <p>Anexa el Acta Constitutiva</p>
                    </div>
                    <div class="col-lg-6">
                      <vue2-dropzone ref="dzActaPoder" 
                                    id="dzActaPoder"
                                    @vdropzone-success="dzSuccess"
                                    @vdropzone-max-files-exceeded="dzMaxFiles(files[4].dzId, $event)"
                                    :options="files[4].dzOpt"
                                    :useCustomSlot="true"
                                    class="border rounded">
                        <div class="dropzone-custom-content">
                          <h4 class="dropzone-custom-title">
                            Arrastra y suelta el archivo aquí
                          </h4>
                          <small class="text-muted">
                            ...o haz click para seleccionar el archivo desde tu computadora.
                          </small>
                        </div>
                      </vue2-dropzone>
                    </div>
                  </div>
                  <hr>
                  <div class="text-right">
                    <base-button nativeType="submit" :disabled='loading'>Enviar Solicitud</base-button>
                  </div>
                </form>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from "vue";
  import axios from 'axios';
  import Multiselect from "vue-multiselect";
  import vue2Dropzone from "vue2-dropzone";
  import 'vue2-dropzone/dist/vue2Dropzone.min.css';
  
  export default {
    name: 'credito',
    components:{
      vue2Dropzone,
      Multiselect
    },
    data() {
      return {
        BASE_URL: process.env.VUE_APP_BASE_URL,
        EMAIL_CREDIT: process.env.VUE_APP_EMAIL_CREDIT_REQUEST,
        loading: true,
        cliente: null,
        cfdiOptions: [
          {code: 'G01', name: 'G01 - Adqusición de mercancias'},
          {code: 'G02', name: 'G02 - Devoluciones, descuentos o bonificaciones'},
          {code: 'G03', name: 'G03 - Gastos en general'},
          {code: 'I01', name: 'I01 - Construcciones'},
          {code: 'I02', name: 'I02 - Mobilario y equipo de oficina por inversiones'},
          {code: 'I03', name: 'I03 - Equipo de transporte'},
          {code: 'I04', name: 'I04 - Equipo de computo y accesorios'},
          {code: 'I05', name: 'I05 - Dados, troqueles, moldes, matrices y herramental'},
          {code: 'I06', name: 'I06 - Comunicaciones telefónicas'},
          {code: 'I07', name: 'I07 - Comunicaciones satelitales'},
          {code: 'I08', name: 'I08 - Otra maquinaria y equipo'},
          {code: 'D01', name: 'D01 - Honorarios médicos, dentales y gastos hospitalarios'},
          {code: 'D02', name: 'D02 - Gastos médicos por incapacidad o discapacidad'},
          {code: 'D03', name: 'D03 - Gastos funerales'},
          {code: 'D04', name: 'D04 - Donativos'},
          {code: 'D05', name: 'D05 - Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)'},
          {code: 'D06', name: 'D06 - Aportaciones voluntarias al SAR'},
          {code: 'D07', name: 'D07 - Primas por seguros de gastos médicos'},
          {code: 'D08', name: 'D08 - Gastos de transportación escolar obligatoria'},
          {code: 'D09', name: 'D09 - Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones'},
          {code: 'D10', name: 'D10 - Pagos por servicios educativos (colegiaturas)'},
          {code: 'P01', name: 'P01 - Por definir'},
        ],
        plazoOptions: [
          "15 días",
          "30 días",
        ],
        razonSocial: null,
        cardCode: null, 
        agenteVentas: null,       
        regimen: null,
        cfdi: null,        
        monto: null,
        plazo: null,
        reqNum: 0,
        files:[
          { code: "const_fiscal",   dzOpt: {}, link: null, dzId: "dzConstFiscal" },
          { code: "comp_domicilio", dzOpt: {}, link: null, dzId: "dzCompDomicilio" },
          { code: "solicitud_cp",   dzOpt: {}, link: null, dzId: "dzSolicitudCP" },
          { code: "ine_rep",        dzOpt: {}, link: null, dzId: "dzIneRep" },
          { code: "acta_poder",     dzOpt: {}, link: null, dzId: "dzActaPoder" }
        ],
        showForm: false,
        rfc: null,
        loadingRFC:false,
        email_sent: false
      }
    },
    created(){
        this.files.forEach(x => {
          x.dzOpt = {
                  url : `${this.BASE_URL}/api/business_partners/credit/upload`,
                  uploadMultiple: false,
                  maxFiles: 1,
                  autoProcessQueue: false,
                  addRemoveLinks: true,
                  acceptedFiles: "image/jpg,image/jpeg,image/png,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          };

        });
    },
    methods:{
      sendRequest(){
        if( this.$refs.dzConstFiscal.getQueuedFiles().length > 0 &&
            this.$refs.dzCompDomicilio.getQueuedFiles().length > 0 &&
            this.$refs.dzSolicitudCP.getQueuedFiles().length > 0 &&
            this.$refs.dzIneRep.getQueuedFiles().length > 0 && (
              this.regimen.Code === '612' ||
              this.$refs.dzActaPoder.getQueuedFiles().length > 0) &&
            this.monto !== null  &&
            this.plazo !== null 
        ){
          this.$swal
            .fire({
              text: "¿Deseas enviar la solicitud de crédito?",
              showCancelButton: true,
              confirmButtonText: "Si",
              cancelButtonText: "No",
              icon:"question"
            })
            .then((response) => {
              if (response.isConfirmed) {   
                this.files.forEach(x => {
                  this.$refs[x.dzId].processQueue();
                });
              }
          });
        }
        else{
          this.$swal("", "Debes llenar todos los campos para hacer la solicitud", "warning");
        }
      },
      dzSuccess(file, response){
        this.files.every(x => {
          if(file.xhr.responseURL.includes(x.code)){
            x.link = response.firebase_url;
            return false;
          } else {
            return true;
          }
        });

        this.reqNum ++;
        if(this.reqNum === this.regimen.Code === '612' ? 4 : 5 && !this.email_sent){
          this.email_sent = true;
          this.sendMail();
          this.reqNum = 0;
        }
      },
      dzMaxFiles(dzId, file){
        this.$refs[dzId].removeFile(file);
        this.$swal("", "Solo puedes subir un archivo", "warning");
      },
      sendMail(){
        let email_body = `<b>Hola un cliente ha solicitado un crédito</b><hr>
                        <b>RFC: </b>${this.rfc}<br>
                        <b>Monto: </b>$${this.monto}<br>
                        <b>Plazo: </b>${this.plazo}<br>
                        <b>Archivos adjuntos: <br>
                        <a target='_blank' clicktracking="off" href='${this.files[0].link}'>Constancia Fiscal</a><br>
                        <a target='_blank' clicktracking="off" href='${this.files[1].link}'>Comprobante de Domicilio</a><br>
                        <a target='_blank' clicktracking="off" href='${this.files[2].link}'>Formato solicitud de crédito</a><br>
                        <a target='_blank' clicktracking="off" href='${this.files[3].link}'>INE</a><br></b>`;
        if(this.regimen.Code !== '612'){
          email_body += `<b></b><a target='_blank' href='${this.files[4].link}'>Acta constitutiva / poder</a><br></b>`
        }
        var json = {
          "to": [this.EMAIL_CREDIT],
          "replyTo": this.EMAIL_CREDIT,
          "email_body": email_body,
          "subject": `Solicitud de crédito - ${this.razonSocial}`
        };
        axios.post('/api/sg/email/send/general', json)
              .then((result) => {
                if(result.data.err){
                  this.$swal("Error", result.data.error.errors[0].message, "error");
                } else {
                  this.$swal("", "Tu solicitud ha sido enviada. El departamento de crédito y cobranza se pondrá en contacto contigo.", "success");
                  this.files.forEach(x => {
                    this.$refs[x.dzId].removeAllFiles();
                    this.monto = null;
                    this.plazo = null; 
                    this.rfc = null;
                    this.cliente = null;

                    this.razonSocial = null;
                    this.cardCode = null; 
                    this.agenteVentas = null;
                    this.regimen = null;
                    this.cfdi = null;
                    
                  });
                }
              }).catch((error) => {
                this.$swal("Error", error, "error");
        });
      },
      validateRFC(){
        this.loadingRFC = true;
        axios.get(`/api/business_part/${this.rfc}`)
        .then((result) => {
          if(result.data.value.length>0){
            // business_part
            this.cliente = result.data.value[0];
            this.razonSocial = this.cliente.CardName;
            this.cardCode = this.cliente.CardCode;
            var url = `${this.BASE_URL}/api/business_partners/credit/upload?card_code=${this.cardCode}&file_type=`
              this.files.forEach(x =>{
                if(this.$refs[x.dzId]){
                  this.$refs[x.dzId].setOption('url', url + x.code);
                  this.$refs[x.dzId].setOption('headers', { "Authorization": axios.defaults.headers.common['Authorization'] });
                }
              });
              
              axios.all([
                axios.get('/api/sales_persons'),
                axios.get('/api/regimen_fiscal'),
              ])
              .then(axios.spread((...responses) => {
                // sales_persons
                this.agenteVentas = responses[0].data.value.find(x => x.SalesEmployeeCode === this.cliente.SalesPersonCode);

                // regimen_fiscal
                this.regimen = responses[1].data.find(x => x.Code === this.cliente.U_TS_RegFiscal);

                // cfdi
                this.cfdi = this.cfdiOptions.find(x => x.code === this.cliente.U_TS_UsoSN);

                this.loading = false;

              }));
              
              this.showForm = true;
              this.loadingRFC = false;
          }
          else{
            this.$swal("", "Este RFC no esta registrado en nuestro sistema", "warning");
            this.loadingRFC = false;
          }
        }).catch((error) => {
          this.loadingRFC = false;
        });
        
      }
    },
    mounted() {
    },
  };
</script>



